export default "__VITE_ASSET__N$YIHMXp__"